import React, { createContext, useReducer, useContext } from "react";
import { v4 } from "uuid";
import Notification from "./Notification";
import "./styles/notification.styles.scss";

export const NotificationContext = createContext();

const normalizeNotificationMessage = (message) => {
  if (typeof message === "string") {
    return message;
  }

  if (Array.isArray(message)) {
    return message
      .map((item) => normalizeNotificationMessage(item))
      .filter(Boolean)
      .join(", ");
  }

  if (message && typeof message === "object") {
    return Object.entries(message)
      .flatMap(([, value]) => {
        const normalizedValue = normalizeNotificationMessage(value);
        return normalizedValue ? [normalizedValue] : [];
      })
      .join(", ");
  }

  if (message === null || message === undefined) {
    return "";
  }

  return String(message);
};

const NotificationProvider = (props) => {
  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case "ADD_NOTIFICATION":
          return [...state, { ...action.payload }];
        case "REMOVE_NOTIFICATION":
          return state.filter((el) => el.id !== action.id);
        default:
          return state;
      }
    },
    [
      // {
      //   id: v4(),
      //   type: "SUCCESS",
      //   message: "Created Successfully!",
      // },
      // {
      //   id: v4(),
      //   type: "ERROR",
      //   message: "Error Occured!",
      // },
    ]
  );

  //   dispatch({
  //     type: "ADD_NOTIFICATION",
  //     payload: {
  //       id: v4(),
  //       type: "SUCCESS",
  //       message: "Created Successfully!",
  //     },
  //   });

  // console.log(state);
  return (
    <NotificationContext.Provider value={dispatch}>
      <div className="notification-wrapper">
        {state.map((note) => (
          <Notification dispatch={dispatch} key={note.id} {...note} />
        ))}
      </div>
      {props.children}
    </NotificationContext.Provider>
  );
};
export const useNotification = () => {
  const dispatch = useContext(NotificationContext);
  return (props) => {
    const normalizedMessage = normalizeNotificationMessage(props.message);

    dispatch({
      type: "ADD_NOTIFICATION",
      payload: {
        id: v4(),
        ...props,
        message: normalizedMessage || "Something went wrong",
      },
    });
  };
};

export default NotificationProvider;
